import { RouteRecordRaw } from 'vue-router'

// 认证相关路由
const authRoutes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: {
      title: '用户登录',
      noAuth: true // 不需要登录验证
    }
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/Auth/Register.vue'),
    meta: {
      title: '用户注册',
      noAuth: true // 不需要登录验证
    }
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: () => import('@/views/Auth/Login.vue'), // 暂时重用登录页
    meta: {
      title: '找回密码',
      noAuth: true // 不需要登录验证
    }
  }
]

export default authRoutes 